import Box from "@mui/material/Box";
import type { ReactNode } from "react";

export interface AuthShellProps {
  brandPanel?: ReactNode;
  children: ReactNode;
}

/** Full-height split layout: optional brand panel + centered form content. */
export function AuthShell({ brandPanel, children }: AuthShellProps) {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {brandPanel}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 2, sm: 4 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
